function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 6,
  fill: "url(#optimize_performance_svg__paint0_linear_447_8281)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.555 5.111c1.112 0 2.126.779 2.216 2.039l.007.183v13.233c0 1.616-1.164 2.323-2.223 2.323-1.09 0-2.123-.758-2.215-2.124l-.007-.2V7.233c0-1.178 1.059-2.12 2.223-2.12zM14 12.89c1.108 0 2.121.704 2.215 1.844l.007.174v5.872c0 1.468-1.164 2.11-2.222 2.11-1.091 0-2.124-.688-2.216-1.93l-.006-.18v-5.963c0-1.071 1.058-1.927 2.222-1.927zm-5.556 5.555a2.222 2.222 0 110 4.445 2.222 2.222 0 010-4.445z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "optimize_performance_svg__paint0_linear_447_8281",
  x1: -14,
  y1: 14,
  x2: 14,
  y2: 42,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#7793FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#D576F0"
})));

var SvgOptimizePerformance = function SvgOptimizePerformance(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgOptimizePerformance;